import { useGetDownloadSignedUrlForExamCenterProctorRequestQuery } from '@exam-center/graphql';

import {
  type ProctorRequestStorageObject,
  useProctorRequestFileNames,
  useProctorRequestFilesWithInfo,
} from '../use-proctor-request-files-with-info';

interface UseGetProctorRequestDownloadSignedUrlWithInfoProps {
  examCenterProctorRequestId: string;
  proctorRequestStorageObject: ProctorRequestStorageObject[];
  options?: {
    skip?: boolean;
  };
}

export function useGetProctorRequestDownloadSignedUrlWithInfo(
  params: Readonly<UseGetProctorRequestDownloadSignedUrlWithInfoProps>,
) {
  const {
    examCenterProctorRequestId,
    proctorRequestStorageObject,
    options: { skip: shouldSkip = false } = {},
  } = params;

  const fileNames = useProctorRequestFileNames(proctorRequestStorageObject);

  const { data } = useGetDownloadSignedUrlForExamCenterProctorRequestQuery({
    variables: {
      getDownloadSignedUrlForExamCenterProctorRequestInput: {
        examCenterProctorRequestId,
        fileNames,
      },
    },
    fetchPolicy: 'no-cache',
    skip: shouldSkip,
  });

  return useProctorRequestFilesWithInfo(
    proctorRequestStorageObject,
    fileNames,
    data?.ecGetDownloadSignedUrlForExamCenterProctorRequest.signedUrls,
  );
}
